module.exports = __webpack_public_path__ + "static/logotype-3676139ac8f3108500050da9aadb945f.svg";